// extracted by mini-css-extract-plugin
module.exports = {"shadowTop":"ClassCard_shadowTop__1ZAq9","shadowBottom":"ClassCard_shadowBottom__YAnm8"};